import Model from '../utils/Model'

export class BlModeType {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const MBL = new BlModeType(1, 'MBL', 'MBL')
export const MBL2 = new BlModeType(2, 'MBL2', 'MBL2')
export const HBL = new BlModeType(3, 'HBL', 'HBL')
export const HBL2 = new BlModeType(4, 'HBL2', 'HBL2')
export const AMS = new BlModeType(5, 'AMS', 'AMS')
export const MAWB = new BlModeType(6, 'MAWB', 'MAWB')
export const HAWB = new BlModeType(7, 'HAWB', 'HAWB')
export const HAWB2 = new BlModeType(9, 'HAWB2', 'HAWB2')
export const AFR = new BlModeType(10, 'AFR', 'AFR')

export const BILL_MODE_TYPES = new Set([MBL, MBL2, HBL, HBL2, AMS, MAWB, HAWB, HAWB2, AFR])

/**
 * return null:没找到.
 */
export function getBillReleaseTypeByCode(code) {
  return Model.getObjByCode(code, BILL_MODE_TYPES)
}
